<template>
  <div class="container">
    <div class="title">
      资料填写
    </div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
      label-position="left"
    >
      <FormItem label="病人性别" prop="sex">
        <RadioGroup v-model="formValidate.sex">
          <Radio label="男">男</Radio>
          <Radio label="女">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="年龄" prop="age">
        <i-Input v-model="formValidate.age" placeholder="请输入年龄"> </i-Input>
      </FormItem>
      <FormItem label="所患疾病" prop="disease">
        <i-Input
          v-model="formValidate.disease"
          placeholder="请填写所患的疾病"
        ></i-Input>
      </FormItem>
      <FormItem label="过敏史" prop="allergies">
        <i-Input
          v-model="formValidate.allergies"
          placeholder="如有过敏史，请填写"
        ></i-Input>
      </FormItem>
      <FormItem label="当前正在使用的药品" prop="used_drugs">
        <i-Input
          v-model="formValidate.used_drugs"
          placeholder="如有当前正在使用的药品，请填写"
        ></i-Input>
      </FormItem>
      <FormItem label="QQ" prop="QQ">
        <i-Input
          v-model="formValidate.QQ"
          placeholder="如有QQ，请填写"
        ></i-Input>
      </FormItem>
      <FormItem label="微信" prop="weixin">
        <i-Input
          v-model="formValidate.weixin"
          placeholder="如有微信，请填写"
        ></i-Input>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <i-Input
          v-model="formValidate.email"
          placeholder="如有邮箱，请填写"
        ></i-Input>
      </FormItem>
      <FormItem label="手机号码" prop="tel">
        <i-Input
          v-model="formValidate.tel"
          placeholder="请输入手机号码"
        ></i-Input>
      </FormItem>
      <div class="verification">
        <div class="left">
          <i-input type="text" placeholder="填写验证码" v-model="verify" />
        </div>
        <div
          class="right"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </div>
      </div>
      <FormItem label="上传病历或处方药图片" prop="IDcard_image">
        <div
          class="demo-upload-list"
          v-for="(item, index) in uploadList"
          :key="index"
        >
          <template v-if="item.status === 'finished'">
            <img :src="item.response.data.url" />
            <div class="demo-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="handleView(item)"
              ></Icon>
              <Icon
                type="ios-trash-outline"
                @click.native="handleRemove(index)"
              ></Icon>
            </div>
          </template>
          <template v-else>
            <Progress
              v-if="item.showProgress"
              :percent="item.percentage"
              hide-info
            ></Progress>
          </template>
        </div>
        <Upload
          ref="upload"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          multiple
          type="drag"
          :action="url"
          :headers="headers"
          style="display: inline-block;width:100px;"
        >
          <div style="width: 100px;height:100px;line-height: 100px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <Modal title="查看图片" v-model="visible">
          <img :src="imgName" v-if="visible" style="width: 100%" />
        </Modal>
      </FormItem>

      <div class="title">
        主治医生信息
      </div>
      <FormItem label="医生名字" prop="doctor">
        <i-Input
          v-model="formValidate.doctor"
          placeholder="请输入主治医生的名字"
        >
        </i-Input>
      </FormItem>
      <FormItem label="手机号码" prop="doctor_tel">
        <i-Input
          v-model="formValidate.doctor_tel"
          placeholder="请输入主治医生的手机号码"
        >
        </i-Input>
      </FormItem>
      <FormItem label="所属医院名称" prop="hospital">
        <Cascader :data="options" @on-change="getHospital"></Cascader>
      </FormItem>
      <FormItem label="所属科室" prop="department">
        <Cascader
          :data="optionsDepartment"
          @on-change="getDepartment"
        ></Cascader>
      </FormItem>

      <div class="title">
        免责申明书
      </div>
      <div class="protocol-content">
        <p>
          欢迎阅读五洲药物国际贸易有限公司《五洲药物商城》服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用《五洲药物商城》应用程序所提供的，在互联网上进行贸易和交流的各种工具和服务(下称“服务”)。本协议在《五洲药物商城》用户接受认证时生效。
        </p>
        <p>
          您在成为《五洲药物商城》认证用户前，必须仔细阅读并接受本协议中所述的所有规则、条款和条件，包括因被提及而纳入的条款和条件。强烈建议您阅读本协议时，同时阅读本协议中提及的其他网页、附件所包含的内容，因为其可能包含对作为《五洲药物商城》用户的您适用的进一步条款和条件。
        </p>
        <div class="more-content">
          <Button type="info" @click="openProtocol">查看更多协议内容</Button>
        </div>
      </div>
      <FormItem prop="type" class="agree">
        <CheckboxGroup v-model="formValidate.type" class="type">
          <Checkbox label="我同意该协议"></Checkbox>
        </CheckboxGroup>
      </FormItem>
      <div class="btn-box">
        <Button type="primary" size="large" @click="handleSubmit()"
          >提交</Button
        >
        <Button size="large" @click="handleReset()" style="margin-left: 8px"
          >重置</Button
        >
      </div>
    </Form>
    <Modal v-model="modal1" title="协议内容" @on-ok="ok" width="980px">
      <div class="protocol-content-1">
        <p>
          欢迎阅读五洲药物国际贸易有限公司《五洲药物商城》服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用《五洲药物商城》应用程序所提供的，在互联网上进行贸易和交流的各种工具和服务(下称“服务”)。本协议在《五洲药物商城》用户接受认证时生效。
        </p>
        <p>
          您在成为《五洲药物商城》认证用户前，必须仔细阅读并接受本协议中所述的所有规则、条款和条件，包括因被提及而纳入的条款和条件。强烈建议您阅读本协议时，同时阅读本协议中提及的其他网页、附件所包含的内容，因为其可能包含对作为《五洲药物商城》用户的您适用的进一步条款和条件。
        </p>
        <br />
        一、用户认证：
        <br />
        <p>
          1．用户认证是指用户登陆《五洲药物商城》应用程序，按要求填写相关信息并确认同意履行相关用户协议的过程。用户因进行交易、获取有偿服务等而发生的所有应纳税赋由用户自行承担。
        </p>
        <p>
          2．限制民事行为能力与无民事行为能力的自然人、无经营或特定经营资格的组织不当认证为《五洲药物商城》用户进行交易的，其与《五洲药物商城》之间的服务协议自始无效，一经发现，《五洲药物商城》有权立即停止与该用户的交易、注销该用户，并追究其使用《五洲药物商城》“服务”的一切法律责任。
        </p>
        <p>
          3．用户在此保证所填写的用户信息是真实、准确、完整、及时的，并且没有任何引人误解或者虚假的陈述，且保证《五洲药物商城》可以通过用户所填写的联系方式与用户取得联系。
        </p>
        <p>
          4．用户应根据《五洲药物商城》对于相关服务的要求及时提供相应的身份证明等资料，否则《五洲药物商城》有权拒绝向该会员或用户提供相关服务
        </p>
        <p>
          5．用户承诺将及时更新其用户信息以维持该等信息的有效性。
        </p>
        <p>
          6．如果用户提供的资料或信息包含有不正确、不真实的信息，《五洲药物商城》保留取消用户会员资格并随时结束为该用户提供服务的权利。
        </p>
        <p>
          7．用户注册成功后将得到一个用户名和密码，用户凭用户名和密码享受《五洲药物商城》向其会员用户提供的商品和服务。
        </p>
        <p>
          8．用户将对用户名和密码安全负全部责任，并且用户对以其用户名进行的所有活动和事件负全责。用户有权根据《五洲药物商城》规定的程序修改密码。
        </p>
        <p>
          9．非经《五洲药物商城》书面同意，用户名和密码不得擅自转让或者授权他人使用，否则用户应承担由此造成的一切后果。
        </p>
        <p>
          10．用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通告《五洲药物商城》。
        </p>
        <br />
        二、商品交易与平台服务：
        <p>
          1．用户在《五洲药物商城》交易商品时必须遵守以下条款：
        </p>
        <p>
          2．用户在使用《五洲药物商城》服务时应遵守所有适用的中国法律、法规、条例和地方性法律的要求。用户还必须确保遵守本协议及纳入本协议的所有其他条款和规则的规定。
        </p>
        <p>
          3．买家在商城上购买药品时，需要提供身份证照片和处方病历图片以供平台审核，经审核认证用户所提供的资料与所购买的药品对应无误后，平台才给予发货。
        </p>
        <p>
          4.买家需要保证所提供的处方、病历、及身份信息的真实有效。
        </p>
        <p>
          5.买家确认在购买相关药品时已咨询过医师，已熟知该药品的禁忌症以及副作用。
        </p>
        <p>
          6．用户通过《五洲药物商城》网站订购商品，订单即为购买商品的申请或要约。但只有当商城向用户发出确认收到订单及送货确认内容的电子数据，才构成商城对该订单的承诺，此时合同即告成立。
        </p>
        <p>
          7．商城有权在发现《五洲药物商城》网站上显示的商品及订单明显错误或缺货的情况下，单方面撤回这些信息或撤销该订单。商城保留对产品订购数量的限制权。
        </p>
        <p>
          8．商品价格和可获性都将在《五洲药物商城》网站上标明，显示的每一项价格都包含了增值税（按照法定税率）。送货费将另外结算，费用根据用户选择的送货方式的不同而异。
        </p>
        <p>
          9．在已确认用户订单后如发生意外的情况，包括但不限于由于供应商提价，税额变化引起的价格变化，或是由于网站的错误等造成价格变化等情况，商城在及时通知用户后有权取消该订单。在商城取消该订单之前，用户亦有权决定是否取消订单。
        </p>
        <br />
        三、用户的权利和义务：
        <p>
          1．用户有权拥有其在《五洲药物商城》的用户名及密码，并随时登陆《五洲药物商城》网站，同时用户可以使用用户信息通过《五洲药物商城》进行交易行为。但不得以任何形式转让或授权他人使用自己的《五洲药物商城》用户名。
        </p>
        <p>
          2．用户有权根据本协议的规定以及《五洲药物商城》网站上发布的相关规则在《五洲药物商城》网站上查询商品信息、发表使用体验、参与商品讨论、邀请关注好友、上传商品图片、参加《五洲药物商城》的有关活动，以及享受《五洲药物商城》提供的其它信息服务。
        </p>
        <p>
          3．用户有义务在认证和交易时提供自己的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性，保证买卖双方可以通过上述联系方式进行联系。同时，用户也有义务在相关资料实际变更时及时更新有关认证资料。用户保证不以他人资料在《五洲药物商城》进行认证和交易行为。
        </p>
        <p>
          4．用户应当保证在使用《五洲药物商城》买卖商品过程中遵守诚实信用原则，不在交易过程中采取不正当行为，不扰乱网上交易的正常秩序。
        </p>
        <p>
          5．用户享有言论自由权利；并拥有适度修改、删除自己发表的文章的权利。
        </p>
        <p>
          6．用户保证其使用《五洲药物商城》服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用《五洲药物商城》提供的服务进行存储、发布、传播如下信息和内容：
        </p>
        <p>(1)违反国家法律、法规政策的任何内容（信息）；</p>
        <p>(2)违反国家规定的政治宣传和/或新闻信息；</p>
        <p>(3)涉及国家秘密和/或安全的信息；</p>
        <p>(4)封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；</p>
        <p>(5)博彩有奖、赌博游戏；</p>
        <p>(6)违反国家民族和宗教政策的信息；</p>
        <p>(7)妨碍互联网运行安全的信息；</p>
        <p>
          (8)侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容。
        </p>
        <p>
          7．用户同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等。用户承认《五洲药物商城》有权在用户违反上述时有权终止向用户提供服务并不于退还任何款项，因用户上述行为给《五洲药物商城》造成损失的，用户应予赔偿。
        </p>
        <p>
          8．用户在发表使用体验、讨论图片等，除遵守本条款外，还应遵守该讨论区的相关规定。
        </p>
        <p>
          9．未经《五洲药物商城》同意，禁止用户在网站发布任何形式的广告。
        </p>
        <br />
        四、《五洲药物商城》的权利和义务：
        <p>
          1．《五洲药物商城》应根据用户选择的服务以及交纳款项的情况向用户提供合格的网络技术和信息服务。
        </p>
        <p>
          2．《五洲药物商城》承诺对用户资料采取对外保密措施，不向第三方披露用户资料，不授权第三方使用用户资料，除非：
        </p>
        <p>
          (1)依据本协议条款或者用户与《五洲药物商城》之间其他服务协议、合同、在线条款等规定可以提供；
        </p>
        <p>(2)依据法律、法规的规定应当提供；</p>
        <p>(3)行政、司法等有权部门要求《五洲药物商城》提供；</p>
        <p>(4)用户同意《五洲药物商城》向第三方提供；</p>
        <p>(5)《五洲药物商城》解决举报事件、提起诉讼而提交的；</p>
        <p>
          (6)《五洲药物商城》为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；
        </p>
        <p>
          (7)《五洲药物商城》为向用户提供产品、服务、信息而向第三方提供的，包括《五洲药物商城》通过第三方的技术及服务向用户提供产品、服务、信息的情况。
        </p>
        <p>3．《五洲药物商城》有权使用用户资料。</p>
        <p>
          4．《五洲药物商城》有权利对用户进行审查并决定是否接受用户成为《五洲药物商城》经营企业会员或是否与用户进行某一交易。
        </p>
        <p>
          5．《五洲药物商城》保留在用户违反国家、地方法律、法规规定或违反本在线认证条款的情况下终止为用户提供服务并终止用户账号的权利，并且在任何情况下，《五洲药物商城》对任何间接、偶然、特殊及继起的损害不负责任。
        </p>
        <br />
        五、违约责任：
        <p>
          1．用户存在下列行为的，视为违约，《五洲药物商城》有权做出相应处理：
        </p>
        <p>
          (1)《五洲药物商城》有权对用户的认证数据及交易行为进行查阅，发现认证数据或交易行为中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接作出删除等处理；
        </p>
        <p>
          (2)经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者《五洲药物商城》有足够事实依据可以认定用户存在违法或违反服务协议行为的，《五洲药物商城》有权在网站上以网络发布形式公布用户的违法行为；
        </p>
        <p>
          (3)对于用户在《五洲药物商城》发布的下列各类信息，《五洲药物商城》有权在不通知用户的前提下进行删除或采取其它限制性措施。包括以炒作信用为目的的信息；《五洲药物商城》有理由相信存在欺诈等恶意或虚假内容的信息；《五洲药物商城》有理由相信存在与网上交易无关或不是以交易为目的的信息；《五洲药物商城》有理由相信存在试图扰乱正常交易秩序因素的信息；《五洲药物商城》有理由相信该信息违反公共利益或可能严重损害《五洲药物商城》和其它用户合法利益的。
        </p>
        <br />
        六、风险承担与规则：
        <p>
          1．如果买家有证据证明因商城产品信息的真实性使买家利益受到损失，商城将对此承担责任；如果是由于买家的错误理解导致利益受到损失，商城将不承担责任。
        </p>
        <p>
          2．如果交易产品质量存在问题，给买家利益造成损失，商城将按照退换货规则承担责任。
        </p>
        <p>
          3．交易达成后，在产品的配送过程中，产品出现毁损、灭失的，与商城无关。
        </p>
        <p>
          4．网络安全问题导致买家利益受到损失，《五洲药物商城》不承担损失赔偿责任，但有义务配合买家进行查询沟通。
        </p>
        <p>
          5．除上述风险承担条款以外，具体的送货、退换货、补货及质量纠纷处理规则等《五洲药物商城》将另行公布。
        </p>
        <br />
        七、服务的中断和终止：
        <p>
          1．如用户向《五洲药物商城》提出注销认证用户身份时，经《五洲药物商城》审核同意，由《五洲药物商城》注销该认证用户，用户即解除与《五洲药物商城》的服务协议关系。但注销该用户账号后，《五洲药物商城》仍保留下列权利：
        </p>
        <p>
          (1)用户注销后，《五洲药物商城》有权保留该用户的认证数据及以前的交易行为记录；
        </p>
        <p>
          (2)用户注销后，如用户在注销前在《五洲药物商城》交易平台上存在违法行为或违反合同的行为，《五洲药物商城》仍可行使本服务协议所规定的权利。
        </p>
        <p>
          2．在下列情况下，《五洲药物商城》可以通过注销用户的方式终止服务：
        </p>
        <p>
          (1)在用户违反本服务协议相关规定时，《五洲药物商城》有权终止向该用户提供服务。《五洲药物商城》将在中断服务时通知用户。但如该用户在《五洲药物商城》终止提供服务后，再一次直接或间接或以他人名义认证为《五洲药物商城》用户的，《五洲药物商城》有权再次单方面终止向该用户提供服务；
        </p>
        <p>
          (2)如《五洲药物商城》通过用户提供的信息与用户联系时，发现用户在认证时填写的电子邮箱已不存在或无法接收电子邮件的，经《五洲药物商城》以其它联系方式通知用户更改，而用户在三个工作日内仍未能提供新的电子邮箱地址的，《五洲药物商城》有权终止向该用户提供服务；
        </p>
        <p>
          (3)一经《五洲药物商城》发现用户认证数据中主要内容是虚假的，《五洲药物商城》有权随时终止向该用户提供服务；
        </p>
        <p>(4)本服务协议终止或更新时，用户明示不愿接受新的服务协议的；</p>
        <p>(5)其它《五洲药物商城》认为需终止服务的情况。</p>
        <br />
        八、适用的法律和管辖权：
        <p>
          用户和《五洲药物商城》之间的服务协议将适用中华人民共和国的法律，管辖地为五洲国际贸易有限公司所在地人民法院。
        </p>
        <br />
        九、知识产权：
        <p>
          1．《五洲药物商城》网站上的图表、标识、网页页眉、按钮图标、文字、服务品名等标示在网站上的信息都是五洲国际贸易有限公司的财产，受中国和国际知识产权法的保护。未经《五洲药物商城》许可，用户不得以任何可能引起消费者混淆的方式或任何贬低或诽谤五洲国际贸易有限公司的方式用于与非《五洲药物商城》的任何产品或服务上。在《五洲药物商城》网站上出现的不属于上述主体的所有其他商标是其商标权利人各自的财产，这些权利人可能是也可能不是与五洲国际贸易有限公司相关联、相联系或由五洲国际贸易有限公司的关联公司赞助的。未经五洲国际贸易有限公司或相关商标所有人的书面许可，《五洲药物商城》网站上的任何东西都不应被解释为以默许或其他方式授予许可或使用网站上出现的商标的权利。
        </p>
        <p>
          2．《五洲药物商城》用户发表的文章仅代表作者本人观点，与《五洲药物商城》立场无关。作者文责自负。
        </p>
        <p>
          3．《五洲药物商城》有权将在本网站发表的产品使用体验、产品讨论或图片自行使用或者与其他人合作使用于其他用途，包括但不限于网站、电子杂志、杂志、刊物等，使用时需为作者署名，以发表文章时注明的署名为准。文章有附带版权声明者除外。
        </p>
        <p>
          4．用户在《五洲药物商城》网站上发表的文章及图片（包括转贴的文章及图片）版权仅归原作者所有，若作者有版权声明或原作从其它网站转载而附带有原版权声明者，其版权归属以附带声明为准。
        </p>
        <br />
        十、不承诺担保和责任限制
        <p>
          1．除非另有明确的书面说明，《五洲药物商城》网站、目录及其所包含的或以其它方式通过本网站提供给用户的全部信息、内容、材料、商品（包括软件）和服务，是由五洲国际贸易有限公司在"按现状"和"按现有"的基础上提供的。
        </p>
        <p>
          2．除非另有明确的书面说明,五洲国际贸易有限公司不对本网站的运营及其包含在本网站上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保（除根据中华人民共和国法律规定的以外）。用户明确同意自担风险使用本网站。
          在适用法律所允许的最大限度内，五洲国际贸易有限公司及其关联公司不承诺所有明示或默示的担保，包括但不限于对适销性和满足特定目的的默示担保。五洲国际贸易有限公司及其关联公司不担保《五洲药物商城》网站、其所包含的或以其它方式通过本网站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从《五洲药物商城》网站发出的电子信件没有病毒或其他有害成分。除非另有明确的书面说明，五洲国际贸易有限公司不对由于使用《五洲药物商城》网站、或由于其所包含的或以其它方式通过本网站提供给用户的全部信息、内容、材料、产品（包括软件）和服务、或购买和使用产品引起的任何损害承担责任（除非根据中华人民共和国法律应承担责任的以外），包括但不限于直接、间接或附带的惩罚性和结果性的损害赔偿。
        </p>
        <br />
        十一、隐私：
        <p>
          五洲药物商城非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，您同意五洲药物商城按照在五洲药物商城平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。如药五洲药物商城网站或客户端未设独立隐私权政策但使用了五洲药物商城平台账号登陆相应网站或客户端的，为保护您的隐私权，我们将参照适用五洲药物商城隐私权政策的要求对您的个人信息进行收集、存储、使用、披露和保护。五洲药物商城希望通过隐私权政策向您清楚地介绍五洲药物商城对您个人信息的处理方式，因此五洲药物商城建议您完整地阅读《五洲药物商城隐私权政策》，以帮助您更好地保护您的隐私权。
        </p>
        <br />
        十二条 附则：
        <p>
          1．本认证条款中有关条款若被权威机构认定为无效，不应影响其他条款的效力，也不影响本服务条款的解释、违约责任及争议解决的有关约定的效力。
        </p>
        <p>
          2．一方变更通知、通讯地址或其他联系方式，应自变更之日起及时将变更后的地址、联系方式通知另一方，否则变更方应对此造成的一切后果承担责任。用户同意，《五洲药物商城》的有关通知只需在《五洲药物商城》有关网页上发布即视为送达用户。
        </p>
        <p>
          3．因《五洲药物商城》上市、被收购、与第三方合并、名称变更等事由，用户同意《五洲药物商城》可以将其权利和/或义务转让给相应的《五洲药物商城》权利/义务的承受者。
        </p>
        <p>
          4．用户在此再次保证已经完全阅读并理解了上述会员认证条款并自愿正式进入《五洲药物商城》入驻会员在线认证程序，接受上述所有条款的约束。
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setUserPatient, registerVerify } from "@api/user";
import UpLoad from "@/mixins/UpLoad";
import axios from "axios";
import SendverifyCode from "@/mixins/SendVerifyCode";
export default {
  data() {
    var ageCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("年龄不能为空"));
      } else {
        if (Number(value) > 0 && Number(value) < 150) {
          callback();
        } else {
          callback(new Error("你输入的信息有误，请重新输入"));
        }
      }
    };
    var telCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系人姓名"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确手机号码"));
        } else {
          callback();
        }
      }
    };
    var doctorTelCheck = (rule, value, callback) => {
      if (value === "") {
        callback();
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确手机号码"));
      } else {
        callback();
      }
    };
    return {
      formValidate: {
        sex: "男",
        age: "",
        disease: "",
        allergies: "",
        used_drugs: "",
        QQ: "",
        weixin: "",
        email: "",
        tel: "",
        IDcard_image: [],
        doctor: "",
        doctor_tel: "",
        hospital: "",
        department: "",
        type: []
      },
      ruleValidate: {
        sex: [{ required: true, trigger: "change" }],
        age: [{ required: true, validator: ageCheck, trigger: "blur" }],
        disease: [
          { required: true, message: "请填写所患的疾病", trigger: "blur" }
        ],
        tel: [{ required: true, validator: telCheck, trigger: "blur" }],
        doctor: [
          { required: true, message: "请填写主治医生名字", trigger: "blur" }
        ],
        doctor_tel: [{ validator: doctorTelCheck, trigger: "blur" }],
        hospital: [{ required: true, message: "请选中所属的医院" }],
        department: [{ required: true, message: "请选中所属的科室" }],
        type: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请勾选",
            trigger: "change"
          }
        ]
      },
      options: [], // 医院的列表
      optionsDepartment: [], // 科室的列表
      modal1: false,
      verify: ""
    };
  },
  mixins: [UpLoad, SendverifyCode],
  created() {
    // 获取静态的医院信息
    axios.get("/hospital.json").then(res => {
      this.options = res.data.hospital;
      this.optionsDepartment = res.data.department;
    });
  },
  methods: {
    handleSubmit() {
      this.uploadList.forEach(item => {
        console.log(item)
        this.formValidate.IDcard_image.push(item.response.data.url);
      });
      console.log(this.uploadList)
      if (this.formValidate.IDcard_image.length < 2) {
        this.$Message.error("需上传病历或处方药图片");
        return;
      }
      if (this.verify.length < 6) {
        this.$Message.error("请填写正确的验证码");
        return;
      }
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          setUserPatient(this.formValidate).then(res => {
            if (res.status === 200) {
              this.$Message.success("提交成功");
              this.$router.push("/home/verifyCenter");
            }
          });
        } else {
          this.$Message.error("请信息填完完整");
        }
      });
    },
    handleReset() {
      this.$refs.formValidate.resetFields();
    },
    getHospital(name) {
      this.formValidate.hospital = name.join("/");
    },
    getDepartment(name) {
      this.formValidate.department = name[1];
    },
    openProtocol() {
      this.modal1 = true;
    },
    ok() {
      this.modal1 = false;
    },
    code() {
      if (this.formValidate.tel === "") {
        this.$Message.error("手机号必须填写");
        return;
      } else if (this.formValidate.tel.length < 11) {
        this.$Message.error("请填写正确的手机号码");
        return;
      }
      this.sendCode();
      const param = {
        phone: this.formValidate.tel,
        type: "verify"
      };
      registerVerify(param).then(() => {
        this.$Message.success("发送成功");
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container .agree /deep/ .ivu-form-item-error-tip
  left -65px
.container
  width: 600px
  margin: 0 auto
  background #fff
  padding: 10px 20px
  .title
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    font-weight: 700;
  .protocol-content
    p
      text-indent 2em
  .more-content
    width 100%
    text-align center
  .type
    position: relative;
    left: -80px;
  .btn-box
    padding: 20px 200px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ddd;
.protocol-content-1
  p
    text-indent 2em
.demo-upload-list
  display: inline-block;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  margin-right: 4px;
.demo-upload-list img
  width: 100%;
  height: 100%;
.demo-upload-list-cover
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.6);
.demo-upload-list:hover .demo-upload-list-cover
  display: block;
.demo-upload-list-cover i
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
.verification
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  margin-left: 80px;
  line-height: 30px;
  .left
    width: 50%;
    input
      width: 100%;
  .right
    width: 40%;
    text-align: center;
    padding: 0 10px;
    background: #409eff;
    color: #fff;
    border-radius: 5px;
    &.on
      background: #dfdfdf;
      color: #595858;
</style>
